module.exports = __webpack_public_path__ + "static/media/workflowWitness.afef7e76.webp";